import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../context';
import type { ActivityResponse } from '../types';

export function useActivities(familyId: string) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['activities', familyId],
    queryFn: () => apiClient.get<ActivityResponse>(`/api/families/${familyId}/activities?limit=20`),
    refetchInterval: 30_000,
    enabled: !!familyId,
  });
}
